import { isMobile } from './isMobile';
import { gameStore } from '../store/gameStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { webGameConfigs, mobileGameConfigs } from '../core/pixi/config';

const {
  IntroBarContainer: {
    symbolPayout,
    payTableStep3Text,
    payTableStep5Text,
    payTableWildScene,
    payTableStep4Text,
    payTableLinesConfig,
    payTableJackpotScene,
    payTableStep1Container,
    payTableStep1ContainerText,
  },
} = isMobile() ? mobileGameConfigs : webGameConfigs;

export const getPayTableSteps = () => {
  return [
    {
      images: [
        {
          anchor: 0.5,
          x: payTableStep1Container.x,
          y: payTableStep1Container.y,
          value: gameMainDrawer.gameAllSprites.paytableWildWeed,
        },
      ],
      texts: [
        {
          anchor: 0.5,
          x: payTableStep1ContainerText.x,
          y: payTableStep1ContainerText.y,
          value: gameStore.canvasTranslationKeys.INTRODUCTION,
          weight: 700,
          fontSize: 20,
          wordWrapWidth: isMobile() ? 400 : 900,
        },
      ],
      stepNumber: 0,
    },
    {
      images: [
        {
          anchor: 0.5,
          x: symbolPayout.x,
          y: symbolPayout.y,
          value: gameMainDrawer.gameAllSprites.symbolPayout,
        },
      ],
      texts: [
        {
          anchor: 0.5,
          x: isMobile() ? 95 : 260,
          y: isMobile() ? 403 : 260,
          value: gameStore.canvasTranslationKeys.SYMBOL_PAYOUT_1,
          weight: 700,
          fontSize: isMobile() ? 10 : 15,
          wordWrapWidth: isMobile() ? 160 : 250,
        },
        {
          anchor: 0.5,
          x: isMobile() ? 280 : 585,
          y: isMobile() ? 403 : 260,
          value: gameStore.canvasTranslationKeys.SYMBOL_PAYOUT_2,
          weight: 700,
          fontSize: isMobile() ? 10 : 15,
          wordWrapWidth: isMobile() ? 160 : 250,
        },
        {
          anchor: 0.5,
          x: isMobile() ? 455 : 910,
          y: isMobile() ? 403 : 260,
          value: gameStore.canvasTranslationKeys.SYMBOL_PAYOUT_3,
          weight: 700,
          fontSize: isMobile() ? 10 : 15,
          wordWrapWidth: isMobile() ? 160 : 250,
        },
      ],
      stepNumber: 1,
    },
    {
      images: [
        {
          anchor: 0.5,
          x: payTableLinesConfig.x,
          y: payTableLinesConfig.y,
          value: gameMainDrawer.gameAllSprites.paytableLines,
        },
      ],
      texts: [
        {
          anchor: 0.5,
          x: payTableStep3Text.x,
          y: payTableStep3Text.y,
          value: gameStore.canvasTranslationKeys.WINNING_LINES_TEXT,
          weight: 700,
          fontSize: 20,
          wordWrapWidth: isMobile() ? 400 : 900,
        },
      ],
      stepNumber: 2,
    },
    {
      images: [
        {
          anchor: 0.5,
          x: payTableWildScene.x,
          y: payTableWildScene.y,
          value: gameMainDrawer.gameAllSprites.paytableWildScane,
        },
      ],
      texts: [
        {
          anchor: 0.5,
          x: payTableStep4Text.x,
          y: payTableStep4Text.y,
          value: gameStore.canvasTranslationKeys.WILDS_TEXT,
          weight: 700,
          fontSize: 20,
          wordWrapWidth: isMobile() ? 400 : 900,
        },
      ],
      stepNumber: 3,
    },
    {
      images: [
        {
          anchor: 0.5,
          x: payTableJackpotScene.x,
          y: payTableJackpotScene.y,
          value: gameMainDrawer.gameAllSprites.paytableJackpot,
        },
      ],
      texts: [
        {
          anchor: 0.5,
          x: payTableStep5Text.x,
          y: payTableStep5Text.y,
          value: gameStore.canvasTranslationKeys.JACKPOT_INTRO,
          weight: 700,
          fontSize: 20,
          wordWrapWidth: isMobile() ? 400 : 900,
        },
      ],
      stepNumber: 4,
    },
  ];
};
